import styled from 'styled-components';
import { Divider as MuiDivider } from '@material-ui/core'; // eslint-disable-next-line @typescript-eslint/no-empty-interface

/** @component */

export const DividerFullWidth = styled(MuiDivider).withConfig({
  displayName: "DividerFullWidth",
  componentId: "sc-1q20z4-0"
})(["width:100%;&&{", "}"], props => props.theme.props.styledPrintRules.header);